<!-- Global toast stack: anchored bottom-right, newest at the bottom. The wrapper
     ignores pointer events so it never blocks the page; each toast re-enables them. -->
<div
  class="fixed z-[100000] bottom-4 right-4 sm:bottom-6 sm:right-6 flex flex-col items-end gap-2 pointer-events-none"
>
  @for (notification of notificationsList; track $index) {
    <pc-alert
      class="pointer-events-auto"
      [appearance]="'outline'"
      [notification]="notification"
      [dismissible]="true"
      [dismissed]="false"
    >
    </pc-alert>
  }
</div>
<!-- Light-mode background flourishes. They are white/indigo tints meant for the
     light slate page; in dark mode they wash the app grey-white instead of the
     plain dark blue, so hide them with `dark:hidden`. They also step aside when a
     Background mesh is picked (`.pc-ambient-flourish`, appearance-backgrounds.css):
     painted over the mesh they washed it to lilac on every routed page. And they
     never print: the right one, 10% past the page edge, widened the printed page
     and Chrome shrank a report's A4 sheets to fit it, off to the left. -->
<div
  class="absolute top-0 left-0 w-full h-[500px] bg-gradient-to-b from-white to-transparent pointer-events-none opacity-60 dark:hidden print:hidden pc-ambient-flourish"
></div>

<div
  class="absolute top-[-20%] right-[-10%] w-[600px] h-[600px] bg-indigo-100/40 rounded-full blur-[100px] pointer-events-none dark:hidden print:hidden pc-ambient-flourish"
></div>

<div
  class="absolute bottom-0 left-[-10%] w-[600px] h-[600px] bg-indigo-100/40 rounded-full blur-[100px] pointer-events-none dark:hidden print:hidden pc-ambient-flourish"
></div>
<router-outlet></router-outlet>
